import React, { FC } from 'react';
import {
  booleanFriendlyOptions,
  DRL_COMPOUNDING_ALIAS,
  DRL_COMPOUNDING_PERIODS_ALIAS,
  DRL_COMPOUNDING_PERIODS_TITLE,
  DRL_COMPOUNDING_TITLE,
  DRL_DIVIDEND_RATE_ALIAS,
  DRL_DIVIDEND_RATE_TITLE,
  DRL_EFFECTIVE_DATE_ALIAS,
  DRL_EFFECTIVE_DATE_TITLE,
  DRL_NAME_ALIAS,
  DRL_NAME_TITLE,
} from 'common/constants/cap-table/capTable';
import { capTableTwoDecimalPercentFormat } from 'common/formats/formats';
import { GridDateProps, Row } from 'common/types/scalarSpreadsheet';
import { SelectValueViewer } from 'components';
import { GridDate, GridDateEditor, GridDateValueViewer, GridSelect } from 'components/FeaturedSpreadsheet/components';

const rowConfig = () =>
  [
    {
      value: DRL_NAME_TITLE,
      alias: DRL_NAME_ALIAS,
      hidden: false,
      readOnly: false,
      gridType: 'string',
      dbType: 'string',
      displayUndefined: true,
      isRequired: true,
    },
    {
      value: DRL_EFFECTIVE_DATE_TITLE,
      alias: DRL_EFFECTIVE_DATE_ALIAS,
      hidden: false,
      readOnly: false,
      gridType: 'gridDate',
      gridDateComponent: GridDate as FC<GridDateProps>,
      dataEditor: (props: any) => <GridDateEditor {...props} />,
      valueViewer: (props: any) => <GridDateValueViewer {...props} slashFormatted />,
      dbType: 'dbDate',
      displayUndefined: true,
      isRequired: true,
    },
    {
      value: DRL_DIVIDEND_RATE_TITLE,
      alias: DRL_DIVIDEND_RATE_ALIAS,
      readOnly: false,
      expr: '',
      format: capTableTwoDecimalPercentFormat,
      gridType: 'percentage',
      dbType: 'string',
      isRequired: true,
    },
    {
      value: DRL_COMPOUNDING_TITLE,
      defaultValue: 0,
      alias: DRL_COMPOUNDING_ALIAS,
      readOnly: false,
      expr: '',
      dataEditor: (props: any) => <GridSelect options={booleanFriendlyOptions} {...props} />,
      valueViewer: (props: any) => <SelectValueViewer {...props} />,
      gridType: 'number',
      dbType: 'boolean',
      minValue: 0,
    },
    {
      value: DRL_COMPOUNDING_PERIODS_TITLE,
      alias: DRL_COMPOUNDING_PERIODS_ALIAS,
      expr: '',
      gridType: 'number',
      dbType: 'string',
      displayUndefined: true,
      allowDecimals: false,
      allowNegativeValue: false,
    },
  ] as Row[];

export default rowConfig;
